import * as React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { NotifyInfo } from 'gossamer-front-end';
import { WebsiteLoginPage } from './WebsiteLoginPage';
import { WebsitePasswordResetPage } from './WebsitePasswordResetPage';
import { WebsitePlanOptionsPage } from './PlanOptions';
import { WebsiteUserRegistrationPage } from './WebsiteUserRegistrationPage';

export const getWebsiteAuthRoutes = (
  signIn: (email: string, password: string) => Promise<NotifyInfo>,
): React.ReactNode => (
  <>
    <Route index element={<Navigate to="login" replace />} />
    <Route path="login" element={<WebsiteLoginPage signIn={signIn} />} />
    <Route path="reset-password" element={<WebsitePasswordResetPage />} />
    <Route path="plan-options" element={<WebsitePlanOptionsPage />} />
    <Route path="user-registration" element={<WebsiteUserRegistrationPage step="details" />} />
    <Route
      path="user-registration/plan-options"
      element={<WebsiteUserRegistrationPage step="plan-options" />}
    />
    <Route
      path="user-registration/institution-name"
      element={<WebsiteUserRegistrationPage step="institution-name" />}
    />
    <Route
      path="user-registration/completed"
      element={<WebsiteUserRegistrationPage step="completed" />}
    />
  </>
);

